'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _propTypes3 = require('../propTypes'),
    _themes = require('../themes'),
    _utils = require('../utils'),
    _FormGroup = require('../FormGroup'),
    _FormGroup2 = _interopRequireDefault(_FormGroup),
    _InputControl = require('../InputControl'),
    _InputControl2 = _interopRequireDefault(_InputControl),
    _TextAreaControl = require('../TextAreaControl'),
    _TextAreaControl2 = _interopRequireDefault(_TextAreaControl);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {};
Styled.InputControl = (0, _styledComponents2.default)(_InputControl2.default).withConfig({
  displayName: 'TextField__InputControl'
})(['display:block;']), Styled.InputControl.displayName = 'Styled_InputControl', Styled.TextAreaControl = (0, _styledComponents2.default)(_TextAreaControl2.default).withConfig({
  displayName: 'TextField__TextAreaControl'
})(['display:block;']), Styled.TextAreaControl.displayName = 'Styled_TextAreaControl';

var TextField = function (_Component) {
  function TextField(props) {
    _classCallCheck(this, TextField);

    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

    return _this.generatedId = (0, _utils.generateUniqueId)('text-field'), _this.state = {
      id: props.id || _this.generatedId,
      validationMessage: ''
    }, _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this;
  }

  return _inherits(TextField, _Component), _createClass(TextField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.id || this.generatedId;
      id !== this.state.id && this.setState({
        id: id
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.nativeFormControl && this.nativeFormControl.focus();
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      this.formControl && this.formControl.validate(callback);
    }
  }, {
    key: 'handleFormControlRef',
    value: function handleFormControlRef(node) {
      this.formControl = node;
    }
  }, {
    key: 'handleNativeFormControlRef',
    value: function handleNativeFormControlRef(node) {
      var nativeFormControlRef = this.props.nativeFormControlRef;
      this.nativeFormControl = node, nativeFormControlRef && nativeFormControlRef(node);
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate(valid, validationMessage) {
      this.setState({
        validationMessage: validationMessage
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          dir = _props.dir,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          helperText = _props.helperText,
          idIgnored = _props.id,
          inheritStyles = _props.inheritStyles,
          label = _props.label,
          labelHidden = _props.labelHidden,
          lang = _props.lang,
          max = _props.max,
          min = _props.min,
          multiline = _props.multiline,
          nativeFormControlRefIgnored = _props.nativeFormControlRef,
          pattern = _props.pattern,
          rootProps = _props.rootProps,
          rows = _props.rows,
          secondary = _props.secondary,
          size = _props.size,
          step = _props.step,
          theme = _props.theme,
          type = _props.type,
          otherProps = _objectWithoutProperties(_props, ['className', 'dir', 'disabled', 'fullWidth', 'helperText', 'id', 'inheritStyles', 'label', 'labelHidden', 'lang', 'max', 'min', 'multiline', 'nativeFormControlRef', 'pattern', 'rootProps', 'rows', 'secondary', 'size', 'step', 'theme', 'type']),
          id = this.state.id,
          validationMessage = this.state.validationMessage,
          conditionalProps = {};

      multiline ? conditionalProps.rows = rows : (conditionalProps.max = max, conditionalProps.min = min, conditionalProps.pattern = pattern, conditionalProps.step = step, conditionalProps.type = type);
      var Control = multiline ? Styled.TextAreaControl : Styled.InputControl;
      return _react2.default.createElement(_FormGroup2.default, {
        className: className,
        dir: dir,
        disabled: disabled,
        formControl: _react2.default.createElement(Control, _extends({}, otherProps, conditionalProps, {
          nativeFormControlRef: this.handleNativeFormControlRef,
          onRef: this.handleFormControlRef,
          onValidate: this.handleValidate
        })),
        fullWidth: fullWidth,
        helperText: helperText,
        id: id,
        inheritStyles: inheritStyles,
        label: label,
        labelHidden: labelHidden,
        lang: lang,
        rootProps: rootProps,
        secondary: secondary,
        size: size,
        theme: theme,
        validationMessage: validationMessage
      });
    }
  }]), TextField;
}(_react.Component);

TextField.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: function defaultValue(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  },
  dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']),
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  helperText: _propTypes2.default.string,
  id: _propTypes2.default.string,
  inheritStyles: _propTypes2.default.bool,
  label: function label(props, propName, componentName) {
    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');

    if (void 0 !== props[propName]) {
      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
      '' === props[propName];
    }
  },
  labelHidden: _propTypes2.default.bool,
  labelledBy: function labelledBy(props, propName, componentName) {
    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');

    if (void 0 !== props[propName]) {
      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
      '' === props[propName];
    }
  },
  lang: _propTypes2.default.string,
  max: function max(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
  },
  maxLength: function maxLength(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
  },
  min: function min(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
  },
  minLength: function minLength(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
  },
  multiline: _propTypes2.default.bool,
  nativeFormControlRef: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  pattern: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  rootProps: _propTypes2.default.object,
  rows: _propTypes2.default.number,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  step: function step(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'any' !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected either `number`, or `string` with a value of "any".');
  },
  theme: _propTypes3.themeShape,
  type: _propTypes2.default.oneOf(['date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week']),
  validate: _propTypes2.default.func,
  value: function value(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  }
}, TextField.defaultProps = {
  rows: 3,
  size: 'medium',
  theme: (0, _themes.createTheme)(),
  validate: function validate() {
    return '';
  }
}, TextField.displayName = 'TextField';
var TextFieldWithTheme = (0, _themes.withTheme)(TextField);
TextFieldWithTheme.WrappedComponent = TextField, exports.default = TextFieldWithTheme;